const useCount = () => {
  return document.getElementById('order-modal-person-count')
}

export default useCount
